import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";

import Sidebar from "./custom/Sidebar";
import Header from "./custom/header";
import MetaTitle from "./custom/MetaTitle";

const SIDEBAR_WIDTH = 270;
const COLLAPSED_WIDTH = 78;
const MOBILE_BREAKPOINT = 768;

const Layout = () => {
    const [isDesktopSidebarOpen, setIsDesktopSidebarOpen] = useState(true);
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
    const [isMobileView, setIsMobileView] = useState(() => {
        if (typeof window === "undefined") {
            return false;
        }

        return window.innerWidth < MOBILE_BREAKPOINT;
    });
    const [selectedMenu, setSelectedMenu] = useState("");
    const [theme, setTheme] = useState(() => {
        try {
            return localStorage.getItem("elee-theme") || "light";
        } catch {
            return "light";
        }
    });

    useEffect(() => {
        document.body.classList.toggle("dark-theme", theme === "dark");
        document.body.dataset.theme = theme;
        localStorage.setItem("elee-theme", theme);
    }, [theme]);

    useEffect(() => {
        const handleResize = () => {
            const nextIsMobile = window.innerWidth < MOBILE_BREAKPOINT;
            setIsMobileView(nextIsMobile);

            if (!nextIsMobile) {
                setIsMobileSidebarOpen(false);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        document.body.style.overflow = isMobileView && isMobileSidebarOpen ? "hidden" : "";

        return () => {
            document.body.style.overflow = "";
        };
    }, [isMobileSidebarOpen, isMobileView]);

    const handleSidebarToggle = () => {
        if (isMobileView) {
            setIsMobileSidebarOpen((current) => !current);
            return;
        }

        setIsDesktopSidebarOpen((current) => !current);
    };

    const sidebarOffset = isMobileView
        ? 0
        : isDesktopSidebarOpen
          ? SIDEBAR_WIDTH
          : COLLAPSED_WIDTH;

    return (
        <div className="app-shell flex min-h-screen">
            <Sidebar
                isOpen={isMobileView ? isMobileSidebarOpen : isDesktopSidebarOpen}
                isMobile={isMobileView}
                onClose={() => setIsMobileSidebarOpen(false)}
                selectedMenu={selectedMenu}
                setSelectedMenu={setSelectedMenu}
            />

            <div
                className="flex flex-1 flex-col overflow-auto transition-all duration-300"
                style={{ marginLeft: `${sidebarOffset}px`, height: "100vh" }}
            >
                <Header
                    selectedMenu={selectedMenu}
                    onToggle={handleSidebarToggle}
                    theme={theme}
                    onThemeToggle={() =>
                        setTheme((current) => (current === "dark" ? "light" : "dark"))
                    }
                />

                <main className="flex-1 overflow-auto p-1.5 lg:p-2">
                    <MetaTitle title={selectedMenu} />
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default Layout;
